export enum DocumentColumnType {
  String = 'string',
  Number = 'number',
  Date = 'date',
  DateTime = 'dateTime',
  Boolean = 'boolean',
  SingleSelect = 'singleSelect',
  Actions = 'actions',
}
